import { createContext, type MutableRefObject } from 'react';

export type PromotionTrackingContextValue = {
  disablePromotionTracking: boolean;
  setDisablePromotionTracking: (disabled: boolean) => void;
  isVirtualPageViewTracked: boolean;
  setIsVirtualPageViewTracked: (tracked: boolean) => void;
  isVirtualPageViewTrackedRef: MutableRefObject<boolean>;
  pageViewKeyRef: MutableRefObject<string | null>;
};

export const PromotionTrackingContext = createContext<PromotionTrackingContextValue | undefined>(undefined);
